"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _textModule = _interopRequireDefault(require("./text.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function Text(props, ref) {
  var _props$type;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classnames["default"])(_textModule["default"].textInput, _defineProperty(_defineProperty({}, _textModule["default"].disabled, props.disabled), _textModule["default"].error, props.error || props.errorState)),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
      children: [props.label, props.helpText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _textModule["default"].help,
        children: props.helpText
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        type: (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'text',
        disabled: props.disabled,
        placeholder: props.placeholder,
        ref: ref,
        onChange: props.onChange,
        name: props.name,
        value: props.value,
        "aria-labelledby": props['aria-labelledby'],
        inputMode: props.inputMode,
        onFocus: props.onFocus,
        onBlur: props.onBlur
      })]
    }), props.error && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _textModule["default"].errorText,
      children: props.error
    })]
  });
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(Text);